import React, { Suspense, useEffect } from "react";
import {
  Routes,
  BrowserRouter,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { pathSpliter } from "../lib/functions";
import { setCurrentRoute } from "../store/commonSlices/routeSlice";
import { App, ConfigProvider } from "antd";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import RouteHandler from "./RouteHandler";

import Loading from "../components/Loading";
import MainLayout from "../layout/MainLayout";
import Login from "../pages/Auth/Login";
import Dashboard from "../pages/Dashboard";
import Workflows from "../pages/Workflows";
import WorkflowAdmin from "../pages/Workflow";
import WorkflowTasks from "../pages/WorkflowTasks";
import Invoice from "../pages/Sales/Invoice";
import SalesReturn from "../pages/SalesReturn/Invoice";
import TatmeenHierarchy from "../pages/TatmeenHierarchy/TatmeenHierarchy";

import Units from "../pages/Units";
import ItemManage from "../pages/Product_manage";
import CreateUnitsForm from "../pages/Units/components/CreateUnitsForm";
import Customers from "../pages/Customers";
import CreateCustomerForm from "../pages/Customers/components/CreateCustomerForm";
import NotFoundPage from "../components/NotFound";
import CreateItemForm from "../pages/Product_manage/components/CreateItemForm";
import ProductReplace from "../pages/ProductReplace";
import CustomerSpecialPrice from "../pages/CustomerSpecialPrice";
import SalesRecord from "../pages/SalesRecord";
import SalesReturnRecord from "../pages/SalesReturnRecord";
import ProductReplaceRecord from "../pages/ProductReplaceRecord";
import ProductTransfer from "../pages/Product_transfer";
import PosEntry from "../pages/POS/PosEntry";
import QuotationRecord from "../pages/QuotationRecord";
import { selectAuthInfo } from "../pages/Auth/authSelectors";
import SalesOrder from "../pages/Order/Sales Order";
import AdjustmentEntry from "../pages/AdjustmentEntry";
import ItemGroupEntry from "../pages/ItemGroup";
import CreateItemGroup from "../pages/ItemGroup/components/CreateGroupForm";
import PurchaseOrder from "../pages/Order/Purchase Order";
import Category from "../pages/category";
import CreateCategory from "../pages/category/components/CreateCategoryForm";
import ItemStock from "../pages/ItemStock";
import ItemLedger from "../pages/ItemLedger";
import AdjustmentRecord from "../pages/AdjustmentRecord";
import Service from "../pages/Service/Service";
import ServiceExpense from "../pages/Service/Service Expense";
import ServiceReturn from "../pages/Service/ServiceReturn";
import TransferRecord from "../pages/TransferRecord";
import TransferPendingRecord from "../pages/TransferPendingRecord";
import TransferReceiveRecord from "../pages/TransferReceiveRecord";
import Models from "../pages/Models";
import CreateModel from "../pages/Models/components/CreateModelsForm";
import Origins from "../pages/Origins";
import Manufacturers from "../pages/Manufacturers";
import CreateOrigins from "../pages/Origins/components/CreateOriginsForm";
import Racks from "../pages/Racks";
import CreateRacks from "../pages/Racks/components/CreateRackForm";
import Purchase from "../pages/Purchase/Purchase";
import PurchaseReturn from "../pages/Purchase/Purchase Return";
import Manufacturing from "../pages/Manufacturing";
import Department from "../pages/Departments";
import CreateDepartment from "../pages/Departments/components/CreateDepartmentForm";
import Designations from "../pages/Designations";
import CreateDesignations from "../pages/Designations/components/CreateDesignationForm";
import CrmCustomers from "../pages/CrmCustomers";
import CreateCrmCustomers from "../pages/CrmCustomers/components/CreateCrmCustomerForm";
import CustomerPendingRecord from "../pages/customerPendingRecord";
import CustomerApprovedRecord from "../pages/CustomerApprovedRecord";
import CustomerRejectedRecord from "../pages/customerRejectedRecord";
import CrmReport from "../pages/CrmReport";
import QuotationEntry from "../pages/Quotation/QuotationEntry";
import SalesVoucher from "../pages/SalesVoucher";
import SalesReturnVoucher from "../pages/SalesReturnVoucher";

import AdvanceTransaction from "../pages/AdvanceTransaction/AdvanceTransaction";
import HrSettingsView from "../pages/HrSettings/hrSettingsview";
import CustomerDue from "../pages/CustomerDueBalanceReport/CustomerDue";
import CustomerDueReport from "../pages/Reports/CustomerDueBalanceInvoicewiseReport/CustomerDueReport";
import Locations from "../pages/Locations";
import CreateLocations from "../pages/Locations/components/CreateLocationForm";
import Accounts from "../pages/Accounts";
import CreateAccounts from "../pages/Accounts/components/CreateAccountForm";
import OpeningBalances from "../pages/Accounts/components/OpeningBalances";
import Contra from "../pages/ContraEntry";
import CreateContra from "../pages/ContraEntry/components/CreateContraForm";
import CreateBranchTransaction from "../pages/BranchTransaction/components/CreateBranchTransactionForm";
import BranchTransactionEntry from "../pages/BranchTransaction";
import Cheques from "../pages/Cheques";
import CreateSupplierForm from "../pages/Purchase/Purchase/Supplier Entry/components/CreateSupplierForm";
import SalaryPaymentReport from "../pages/salaryPaymentReport";
import MonthlySalaryReport from "../pages/MonthlySalaryReport";
import Warehouses from "../pages/Settings/warehouses";
import CreateWarehouses from "../pages/Settings/warehouses/components/CreateWarehouseForm";
import SalesReturnLedger from "../pages/SalesReturnLedger";
import SalesLedger from "../pages/SalesLedger";
import AdvanceCustomerBalanceReport from "../pages/AdvanceCustomerBalanceReport";
import PurchaseReturnLedger from "../pages/PurchaseReturnLedger";
import PurchaseAccountLedger from "../pages/PurchaseAccountLedger";
import PurchaseRecord from "../pages/Purchase/Purchase/PurchaseRecord";
import PurchaseReturnRecord from "../pages/Purchase/Purchase Return/PurchaseReturnRecord";
import IndirectExpenseLedger from "../pages/IndirectExpenseLedger";
import DirectExpenseLedger from "../pages/DirectExpenseLedger";
import DirectExpenseBalance from "../pages/DirectExpenseBalance";
import ExpenseRecognitionRecord from "../pages/ExpenseRecognitionRecord";
import CollectionReport from "../pages/Reports/SalesCollectionRecord/CollectionReport";

import CustomerReceipts from "../pages/CustomerReceipts/CustomerReceipts";
import CustomerReceiptList from "../pages/CustomerReceipts/CustomerReceiptsList";
import DebtorReceiptRecord from "../pages/Reports/CustomerReceiptRecord/DebtorReceiptRecord";
import EMIDueReport from "../pages/Reports/CustomerEmiReport/EMIDueReport";
import SupplierPaymentList from "../pages/supplierPayments/SupplierPaymentList";
import SupplierPayments from "../pages/supplierPayments/SupplierPayments";
import SupplierPaymentVoucher from "../pages/supplierPayments/SupplierPaymentVoucher";
import ExpenseList from "../pages/expenses/ExpenseList";
import ExpenseEntry from "../pages/expenses/ExpenseEntry";
import ExpenseRecognitionList from "../pages/ExpenseRecognitions/ExpenseRecognitionsList";
import ExpenseRecognitionEntry from "../pages/ExpenseRecognitions/ExpenseRecognitionsEntry";
import IncomeList from "../pages/Income/IncomeList";
import IncomeEntry from "../pages/Income/IncomeEntry";
import JournalList from "../pages/Journal/JournalList";
import JournalEntry from "../pages/Journal/JournalEntry";
import SupplierDue from "../pages/Reports/SupplierDueBalance/SupplierDue";
import SupplierOutflow from "../pages/Reports/SupplierWiseOutflow/SupplierOutflow";
import OutstandingPdc from "../pages/Reports/OutstandingPdc/OutstandingPdc";
import SupplierLedger from "../pages/Reports/SupplierLedger";
import ExpenseBalanceReport from "../pages/Reports/ExpenseBalance";
import ExpenseRecord from "../pages/Reports/ExpenseRecord";
import CreditorPaymentRecord from "../pages/Reports/SupplierPaymentRecord/CreditorPaymentRecord";
import AdvanceCreditor from "../pages/Reports/AdvanceSupplierBalance/AdvanceCreditor";
import SalaryPaymentList from "../pages/SalaryPayments/SalaryPaymentList";
import SalaryPaymentEntry from "../pages/SalaryPayments/SalaryPaymentEntry";
import BranchLocation from "../pages/BranchLocation/hrlocation";
import ReportDashboard from "../pages/Reports/ReportDashboard";
import AccountBalance from "../pages/AccountBalance";
import CashBankAccountLedger from "../pages/Reports/CashBankAccountLedger";
import DailyLedger from "../pages/Reports/DailyLedger";
import ProfitLossReport from "../pages/Reports/ProfitLossReport";
import LoanBalance from "../pages/Reports/LoanBalance";
import LoanBalanceLedger from "../pages/Reports/LoanBalanceLedger";
import BranchTransferList from "../pages/Reports/BranchTransferList";
import IndirectIncomeBalanceLedger from "../pages/Reports/IndirectIncomeBalanceLedger";
import BalanceSheet from "../pages/Reports/BalanceSheet";
import TrialBalance from "../pages/Reports/TrialBalance";
import BankTransactionPage from "../pages/BankTransaction/BankTransactionPage";
import SettingsDashboard from "../pages/Settings/SettingsDashboard";
import BranchEntry from "../pages/Settings/Branches/BranchEntry";
import CreateBranchForm from "../pages/Settings/Branches/components/CreateBranchForm";
import TagManage from "../pages/Settings/Tags/TagManage";
import UserManage from "../pages/Settings/Users/UserManage";
import IndirectIncomeBalance from "../pages/Reports/IndirectIncomeBalance";
import DirectIncomeBalance from "../pages/Reports/DirectIncomeBalance";
import BranchTransferReceiveList from "../pages/Reports/BranchTransferReceiveList";
import BranchTransferPendingList from "../pages/Reports/BranchTransferPendingList";
import DirectIncomeBalanceLedger from "../pages/Reports/DirectIncomeBalanceLedger";
import InstitutionProfile from "../pages/Settings/CompanyProfile/InstitutionProfile";
import SalesTaxLedger from "../pages/Reports/TaxLedger";
import CurrentAssetLedger from "../pages/Reports/CurrentAssetLedger";
import FixedAssetLedger from "../pages/Reports/FixedAssetLedger";
import FixedAssetBalance from "../pages/Reports/FixedAssetBalance";
import BranchLedger from "../pages/Reports/BranchLedger";
import CapitalLedger from "../pages/Reports/CapitalLedger";
import BranchTransactionInward from "../pages/Reports/BranchTransactionInward";
import BranchTransactionOutward from "../pages/Reports/BranchTransactionOutward";
import BranchBalance from "../pages/Reports/BranchBalance";
import CapitalBalance from "../pages/Reports/CapitalBalance";
import IncomeRecord from "../pages/Reports/IncomeRecord";
import ContraRecord from "../pages/Reports/ContraRecord";
import ServiceExpenseLedger from "../pages/Reports/ServiceExpenseLedger";
import ManufacturingRecord from "../pages/Manufacturing/ManufacturingRecord";
import CurrentAssetBalance from "../pages/Reports/CurrentAssetBalance";
import BillWiseProfitLossReport from "../pages/Reports/BillWiseProfitLoss/BillWiseProfitLossReport";
import ItemProfitLossReport from "../pages/Reports/ItemProfitLoss/ItemProfitLossReport";
import CustomerLedger from "../pages/Reports/CustomerLedger/CustomerLedger";
import ReserveSurplusLedgerReport from "../pages/Reports/ReserveSurplusLedger/ReserveSurplusLedger";
import ReserveSurplusBalanceReport from "../pages/Reports/ReserveSurplusBalance/ReserveSurplusBalanceReport";
import SuspenseLedgerReport from "../pages/Reports/SuspenseLedger/SuspenseLedgerReport";
import SuspenseBalanceReport from "../pages/Reports/SuspenseBalance/SuspenseBalanceReport";
import CurrentLiabilityLedgerReport from "../pages/Reports/CurrentLiability/CurrentLiabilityLedgerReport";
import CurrentLiabilityBalanceReport from "../pages/Reports/CurrentLiability/CurrentLiabilityBalanceReport";
import DepositAccountLedgerReport from "../pages/Reports/DepositAccount/DepositAccountLedgerReport";
import PackingStructureForm from "../pages/Product_manage/PackingStructure/PackingStructureForm";
import ServiceAccountLedger from "../pages/Reports/ServiceAccountLedger";
import InvestmentAccountLedger from "../pages/Reports/InvestmentAccountLedger";
import JournalRecord from "../pages/Reports/JournalRecord";
import DepositAccountRecord from "../pages/Reports/DepositAccount/DepositAccountRecord";
import InvestmentBalanceReport from "../pages/Reports/InvestmentBalance/InvestmentBalanceReport";
import EmiDueList from "../pages/Reports/CustomerEmiReport/EMIDueListSinglePage";
import AdminDashboard from "../pages/AdminDashboard";
import TermsOfService from "../pages/Supports/TermsOfService";
import PrivacyPolicy from "../pages/Supports/PrivacyPolicy";
import CookiesPolicy from "../pages/Supports/CookiesPolicy";
import ContactSupport from "../pages/Supports/ContactSupport";
import SalesDashboard from "../pages/SalesDashboard";
import QuotationDashboard from "../pages/Quotation/QuotationDashboard";
import OrderDashboard from "../pages/Order/OrderDashboard";
import ServiceDashboard from "../pages/Service/ServiceDashboard";
import PurchaseDashboard from "../pages/Purchase/PurchaseDashboard";
import TatmeenModule from "../pages/Tatmeen/Packing";
import InventoryDashboard from "../pages/InventoryDashboard";
import AccountsDashboard from "../pages/AccountsDashboard";
import HRPayrollDashboardOld from "../pages/HRPayrollDashboardOld";
import HRPayrollDashboard from "../pages/HrPayrollDashboard/index";
import CRMDashboard from "../pages/CrmDashboard/index";
import AttendanceOverview from "../pages/AttendanceOverview";
import ClientsDashboard from "../pages/Clients/ClientsDashboard";
import EmployeesPage from "../pages/Employees";
import PatientsOverview from "../pages/PatientsOverview";
import DoctorsOverview from "../pages/DoctorsOverview";
import UserRoleManage from "../pages/Settings/UserRoles/UserRoleManage";
import ModuleAccessManage from "../pages/Settings/ModuleAccess/ModuleAccessManage";
import QuotationQuickVoucher from "../pages/Quotation/components/QuotationQuickVoucher";
import PosQuickVoucher from "../pages/POS/components/PosQuickVoucher";
import PurchaseEntry from "../pages/Purchase/Purchase/Purchase Entry/PurchaseEntry";
import ManufacturingQuickVoucher from "../pages/Manufacturing/Manufacturing Entry/components/ManufacturingQuickVoucher";
import PurchaseQuickVoucher from "../pages/Purchase/Purchase/Purchase Entry/components/PurchaseQuickVoucher";
import PurchaseReturnQuickVoucher from "../pages/Purchase/Purchase Return/Purchase Return Entry/components/PurchaseReturnQuickVoucher";
import SalesReturnQuickVoucher from "../pages/SalesReturn/Invoice/components/SalesReturnQuickVoucher";
import ProductReplaceVoucherQuick from "../pages/ProductReplace/components/ProductReplaceVoucherQuick";
import QuickSalesOrderVoucher from "../pages/Order/Sales Order/Sales Order Entry/components/QuickSalesOrderVoucher";
import QuickPurchaseOrderVoucher from "../pages/Order/Purchase Order/Purchase Order Entry/components/QuickPurchaseOrderVoucher";
import QuickServiceVoucher from "../pages/Service/Service/Service Entry/components/QuickServiceVoucher";
import ServiceExpenseVoucherQuick from "../pages/Service/Service Expense/Service Expense Entry/components/ServiceExpenseVoucherQuick";
import QuickTransferVoucher from "../pages/TransferRecord/components/QuickTransferVoucher";
import SalesQuickVoucher from "../pages/Sales/Invoice/components/SalesQuickVoucher";
import ClientsList from "../pages/ATS/ClientsList";
import AgenciesList from "../pages/ATS/AgenciesList";
import CandidatesList from "../pages/ATS/Candidate/CandidatesList";
import CreateCandidate from "../pages/ATS/Candidate/CreateCandidate";
import ViewCandidate from "../pages/ATS/Candidate/ViewCandidate";
import EditCandidate from "../pages/ATS/Candidate/EditCandidate";
import JobNewOrEdit from "../pages/ATS/Jobs/JobNewOrEdit";
import JobView from "../pages/ATS/Jobs/JobView";
import PublicJobView from "../pages/ATS/Jobs/PublicJobView";
import JobsList from "../pages/ATS/Jobs/JobsList";
import InvoicePharma from "../pages/SalesPharma/Invoice";
import SalesPharmaQuickVoucher from "../pages/SalesPharma/Invoice/components/SalesPharmaQuickVoucher";
import InsuranceReceiptList from "../pages/InsuranceReciepts/InsuranceReceiptList";
import InsuranceReceipts from "../pages/InsuranceReciepts/InsuranceReceipts";
import SalaryPaymentVoucher from "../pages/MonthlySalaryReport/components/SalaryPaymentVoucher";
import ATSDashboard from "../pages/ATS/ATSDashboard";
import CandidateApplyForm from "../pages/ATS/Candidate/CandidateApplyForm";

import LandingPasswordChange from "../pages/LandingPasswordSet";
import ApplicationView from "../pages/ATS/Application/ApplicationView";
import WorkflowBuilder from "../pages/ATS/Workflow/WorkflowBuilder";
import WorkflowList from "../pages/ATS/Workflow/WorkflowList";

import FlowEditor from "../pages/ATS/Workflow/FlowEditor";

import SalesTabs from "../pages/SalesTabs";
import SalesReturnTabs from "../pages/SalesReturnTab";
import SalesRepleceTabs from "../pages/SalesReplaceRecord";

import TaskManager from "../pages/ATS/Task/TaskManager";
import ActivitiesPage from "../pages/Activities/Activities";
import ClientApproveAttendance from "../pages/ClientApproveAttendance/approve_attendance";
import UserPasswordChange from "../pages/UserEmailPassword";
import QuotationTabs from "../pages/QuotationTabs";
import WorkflowRecords from "../pages/ATS/Workflow/WorkflowRecords";
import WorkflowTaskFlow from "../pages/ATS/Workflow/WorkflowTaskFlow";
import AttendanceTabs from "../pages/AttendanceTab";
import CustomerReceiptVoucher from "../pages/CustomerReceipts/CustomerReceiptVoucher";
import AdvanceTransactionReceipt from "../pages/AdvanceTransaction/components/AdvanceTransactionReceipt";
import PurchaseOrderEntry from "../pages/Order/Purchase Order/Purchase Order Entry/PurchaseOrderEntry";
import ServiceEntry from "../pages/Service/Service/Service Entry/ServiceEntry";
import ServiceExpenseEntry from "../pages/Service/Service Expense/Service Expense Entry/ServiceExpenseEntry";
import PrintSalesVoucher from "../pages/SalesVoucher/components/PrintSalesVoucher";
import PrintRenderer from "../pages/PrintRenderer";
import PayslipPrintPuppeteer from "../pages/Employees/components/EmployeePayslip/PayslipPrintPuppeteer";
import PrintQuotationVoucher from "../pages/Quotation/components/PrintQuotationVoucher";
import OnboardingPage from "../pages/Onboarding";
import OnboardingForm from "../pages/Onboarding/components/OnboardingForm";
import Leads from "../pages/Crm/Leads";
import Deals from "../pages/Crm/Deals";
import SubscriptionPage from "../pages/Settings/subscriptionManage/SubscriptionPage";
import Performance from "../pages/Crm/Performance/Index";
import MyWork from "../pages/Crm/MyWork";
import TaskTabs from "../pages/Crm/TodayTasks";
import LeadDetail from "../pages/Crm/Leads/components/LeadDetail";
import GSTR3BSummary from "../pages/Reports/GSTR3BSummary";
import SalesReturnGSTR1 from "../pages/Reports/SalesReturnGSTR1";
import PurchaseReturnGSTR2 from "../pages/Reports/PurchaseReturnGSTR2";
import IntangibleAssetBalance from "../pages/Reports/IntangibleAsset";
import AgeingReport from "../pages/Reports/AgeingReport";
import UniversalLedger from "../pages/Reports/AccountTransactionReport";
import IdleTimerWrapper from "../components/IdleTimeWrapper";
import IntangibleAssetLedger from "../pages/Reports/IntangibleAssetLedger/IntangibleAssetLedger";
import RecurringJournalList from "../pages/RecurringJournals/RecurringJournalList";
import RecurringJournalEntry from "../pages/RecurringJournals/RecurringJournalEntry";
import CRMCustomize from "../pages/Crm/CrmCustomize/CRMCustomize";
import DealDetails from "../pages/Crm/Deals/components/DealDetails";
import TaskDetails from "../pages/Crm/TodayTasks/components/TaskDetails";
import WorkRoutes from "../pages/WorkRoutes";
import { featureFlags } from "../lib/featureFlags";
import SSCCAggregation from "../pages/Tatmeen/SSCCAggregation/SSCCAggregation";
import DeliveryModule from "../pages/Delivery";
import DeliveryJobDetail from "../pages/Delivery/components/DeliveryJobDetail";
import { hasWorkflowAccess } from "../lib/workflowAccess";
import CreateGenericNameForm from "../pages/GenericNames/components/CreateGenericNameForm";
import GenericNameList from "../pages/GenericNames/components/GenericNameList";
import GenericName from "../pages/GenericNames";

const themeObj = {
  token: {
    colorText: "#484848",
    fontSize: 16,
  },
};

const AppRoutes = () => {
  const dispatch = useDispatch();
  const authInfo = useSelector(selectAuthInfo);
  const currentRoute = useSelector((state) => state.route);
  const { auth_info, isAuthenticated } = useSelector((state) => state.auth);
  const hiddenWorkflowRoute = <Navigate to="/" replace />;
  const canUseWorkflows = hasWorkflowAccess(authInfo);

  useEffect(() => {
    dispatch(setCurrentRoute(pathSpliter(window.location.pathname, 1)));
  }, [dispatch]);

  return (
    <ConfigProvider theme={themeObj}>
      <App>
        <Suspense fallback={<Loading />}>
          <BrowserRouter>
            <RouteHandler />
            <Routes>
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <Login />
                  </PublicRoute>
                }
              />

              {/* Standalone print routes */}
              <Route path="/print/sales/:sale_id" element={<PrintSalesVoucher />} />
              <Route path="/print/quotation/:id" element={<PrintQuotationVoucher />} />
              <Route path="/print/:docType/:id" element={<PrintRenderer />} />
              <Route path="/print/payslip/:employeeId/:month/:year" element={<PayslipPrintPuppeteer />} />
              <Route path="/print/payslip" element={<PayslipPrintPuppeteer />} />
              <Route path="/aggregate" element={<SSCCAggregation />} />

              <Route
                path="/set-user-password/:token"
                element={<LandingPasswordChange />}
              />

              <Route
                path="/attendance-approve/:token"
                element={<ClientApproveAttendance />}
              />

              <Route
                path="/user-password-change/:token"
                element={<UserPasswordChange />}
              />

              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <IdleTimerWrapper>
                      <MainLayout />
                    </IdleTimerWrapper>
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={<Navigate to={auth_info?.route_path} replace />}
                />
                <Route
                  path="/admin-dashboard"
                  element={<AdminDashboard authInfo={authInfo} />}
                />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route
                  path="/workflows"
                  element={
                    canUseWorkflows ? <Workflows /> : hiddenWorkflowRoute
                  }
                />
                <Route
                  path="/workflow-admin"
                  element={
                    canUseWorkflows ? (
                      <WorkflowAdmin />
                    ) : (
                      hiddenWorkflowRoute
                    )
                  }
                />
                <Route
                  path="/workflow-tasks"
                  element={
                    canUseWorkflows ? (
                      <WorkflowTasks />
                    ) : (
                      hiddenWorkflowRoute
                    )
                  }
                />
                <Route path="/sales-dashboard" element={<SalesDashboard />} />
                <Route path="/sales" element={<SalesTabs authInfo={authInfo} />} />
                <Route path="/sales-returns" element={<SalesReturnTabs authInfo={authInfo} />} />
                {/* <Route path="/sales-replace" element={<SalesRepleceTabs authInfo={authInfo} />} /> */}

                <Route
                  path="/invoice"
                  element={<Invoice authInfo={authInfo} />}
                />
                <Route
                  path="/sales/pharma-sales"
                  element={<InvoicePharma authInfo={authInfo} />}
                />
                <Route
                  path="/pharma-sales/:id"
                  element={<InvoicePharma authInfo={authInfo} />}
                />
                <Route
                  path="/invoice/:id"
                  element={<Invoice authInfo={authInfo} />}
                />
                <Route path="/customers" element={<Customers authInfo={authInfo} />} />
                <Route
                  path="/customers/addNewCustomer"
                  element={<CreateCustomerForm authInfo={authInfo} />}
                />
                <Route
                  path="/sales-return"
                  element={<SalesReturn authInfo={authInfo} />}
                />
                <Route
                  path="/inventory/heirrachy-flow"
                  element={<TatmeenHierarchy authInfo={authInfo} />}
                />
                {/* <Route path="/product-replace" element={<ProductReplace authInfo={authInfo} />} />
                <Route
                  path="/product-replace/:id"
                  element={<ProductReplace authInfo={authInfo} />}
                />
                <Route
                  path="/sales/quick-replace-voucher/:id"
                  element={<ProductReplaceVoucherQuick />}
                /> */}
                <Route
                  path="/customer-special-price"
                  element={<CustomerSpecialPrice />}
                />
                <Route
                  path="/sales/view-sales-voucher"
                  element={<SalesVoucher authInfo={authInfo} />}
                />

                <Route
                  path="/sales/view-sales-return-voucher"
                  element={<SalesReturnVoucher />}
                />
                <Route
                  path="/sales/quick-sales-voucher/:id"
                  element={
                    <SalesQuickVoucher
                      authInfo={authInfo}
                      currentRouteSet={currentRoute}
                    />
                  }
                />
                <Route
                  path="/sales/quick-sales-pharma-voucher/:id"
                  element={
                    <SalesPharmaQuickVoucher
                      authInfo={authInfo}
                      currentRouteSet={currentRoute}
                    />
                  }
                />
                <Route
                  path="/sales/quick-sales-return-voucher/:id"
                  element={<SalesReturnQuickVoucher authInfo={authInfo} />}
                />
                <Route path="/sales-record" element={<SalesRecord />} />
                <Route
                  path="/sales-return-record"
                  element={<SalesReturnRecord />}
                />
                {/* <Route
                  path="/product-replace-record"
                  element={<ProductReplaceRecord />}
                /> */}
                <Route path="/pos/pos-entry" element={<PosEntry />} />
                <Route
                  path="/sales/quick-pos/:id"
                  element={<PosQuickVoucher />}
                />
                <Route
                  path="/quotation/dashboard"
                  element={<QuotationDashboard />}
                />
                <Route path="/quotations" element={<QuotationTabs />} />
                <Route
                  path="/quotation/quotation"
                  element={<QuotationEntry />}
                />
                <Route
                  path="/quotation/quick-quotation-voucher/:id"
                  element={<QuotationQuickVoucher />}
                />
                <Route
                  path="/quotation/quotation-record"
                  element={<QuotationRecord />}
                />
                <Route
                  path="/purchase/order-to-purchase/:id"
                  element={<PurchaseEntry />}
                />
                <Route
                  path="/sales/order-to-sales/:id"
                  element={<Invoice authInfo={authInfo} />}
                />
                <Route
                  path="/sales/quotation-to-sales/:quoteId"
                  element={<Invoice authInfo={authInfo} />}
                />
                <Route
                  path="/sales/pharma-quotation-to-sales/:quoteId"
                  element={<InvoicePharma authInfo={authInfo} />}
                />
                <Route
                  path="/order/quotation-to-order/:quoteId"
                  element={<SalesOrder />}
                />
                <Route path="/order/dashboard" element={<OrderDashboard />} />
                <Route path="/order/sales" element={<SalesOrder />} />
                <Route
                  path="/order/sales-order-entry/:edit_sale_o_id"
                  element={<SalesOrder />}
                />
                <Route
                  path="/order/quick-sales-order-voucher/:id"
                  element={<QuickSalesOrderVoucher authInfo={authInfo} />}
                />
                <Route path="/order/purchase" element={<PurchaseOrder />} />
                <Route
                  path="/order/purchase-order-update/:id"
                  element={<PurchaseOrderEntry />}
                />
                <Route
                  path="/purchase/purchase-update/:id"
                  element={<PurchaseOrder />}
                />
                <Route
                  path="/order/quick-purchase-order-voucher/:id"
                  element={<QuickPurchaseOrderVoucher authInfo={authInfo} />}
                />
                <Route
                  path="/purchase/purchase-return-update/:id"
                  element={<PurchaseReturn />}
                />
                <Route
                  path="/sales-return/edit/:sale_r_id"
                  element={<SalesReturn />}
                />
                <Route
                  path="/service/dashboard"
                  element={<ServiceDashboard />}
                />
                <Route path="/service" element={<Service />} />
                <Route
                  path="/service/quick-service-voucher/:id"
                  element={<QuickServiceVoucher authInfo={authInfo} />}
                />
                <Route
                  path="/service/service-update/:id"
                  element={<ServiceEntry />}
                />
                <Route path="/service-return" element={<ServiceReturn />} />
                <Route path="/service-expense" element={<ServiceExpense />} />
                <Route
                  path="/service/service-expense-update/:id"
                  element={<ServiceExpenseEntry />}
                />
                <Route
                  path="/service/quick-service-expense-voucher/:id"
                  element={<ServiceExpenseVoucherQuick authInfo={authInfo} />}
                />
                <Route
                  path="/purchase/dashboard"
                  element={<PurchaseDashboard />}
                />
                <Route
                  path="/tatmeen"
                  element={<TatmeenModule />}
                />
                <Route
                  path="/purchase"
                  element={<Purchase authInfo={authInfo} />}
                />
                <Route
                  path="/purchase/edit/:id"
                  element={<PurchaseEntry authInfo={authInfo} />}
                />
                <Route
                  path="/purchase/addNewSupplier"
                  element={<CreateSupplierForm />}
                />
                <Route path="/purchase-return" element={<PurchaseReturn />} />
                <Route path="/purchase-return/:id" element={<PurchaseReturn />} />
                <Route
                  path="/purchase/quick-purchase-voucher/:id"
                  element={<PurchaseQuickVoucher authInfo={authInfo} />}
                />
                <Route
                  path="/purchase/quick-purchase-return-voucher/:id"
                  element={<PurchaseReturnQuickVoucher authInfo={authInfo} />}
                />
                <Route path="/manufacturing" element={<Manufacturing />} />
                <Route
                  path="/manufacturing-quick-voucher/:id"
                  element={<ManufacturingQuickVoucher />}
                />
                <Route
                  path="/manufacturing/:id"
                  element={<Manufacturing />}
                />
                <Route
                  path="/inventory/dashboard"
                  element={<InventoryDashboard />}
                />
                <Route path="/unit-manage" element={<Units />} />
                <Route
                  path="/unit-manage/addNewUnit"
                  element={<CreateUnitsForm />}
                />
                <Route
                  path="/item-manage"
                  element={<ItemManage authInfo={authInfo} />}
                />
                <Route
                  path="/item-manage/addNewItem"
                  element={<CreateItemForm />}
                />
                <Route
                  path="/unit-manage/addNewUnit"
                  element={<CreateUnitsForm />}
                />
                <Route
                  path="/inventory/product/addPacking"
                  element={<PackingStructureForm />}
                />
                <Route path="/inventory/unit-manage" element={<Units />} />
                <Route
                  path="/inventory/unit-manage/addNewUnit"
                  element={<CreateUnitsForm />}
                />
                <Route
                  path="/inventory/product"
                  element={<ItemManage authInfo={authInfo} />}
                />
                <Route
                  path="/inventory/product/addNewItem"
                  element={<CreateItemForm />}
                />
                <Route
                  path="/inventory/transfer-entry"
                  element={<ProductTransfer authInfo={authInfo} />}
                />
                <Route
                  path="/inventory/transfer-entry/edit/:id"
                  element={<ProductTransfer authInfo={authInfo} />}
                />
                <Route
                  path="/inventory/item-adjustment"
                  element={<AdjustmentEntry />}
                />
                <Route
                  path="/inventory/item-adjustment/edit/:id"
                  element={<AdjustmentEntry />}
                />
                <Route
                  path="/inventory/item-group-entry"
                  element={<ItemGroupEntry />}
                />
                <Route
                  path="/inventory/item-group-entry/addNewGroup"
                  element={<CreateItemGroup />}
                />
                <Route path="/inventory/category" element={<Category />} />
                <Route
                  path="/inventory/category/addNewCategory"
                  element={<CreateCategory />}
                />
                <Route
                  path="/inventory/item-stock-report"
                  element={<ItemStock />}
                />
                <Route
                  path="/reports/item-stock-report"
                  element={<ItemStock />}
                />
                <Route
                  path="/reports/item-stock-report/:id"
                  element={<ItemStock />}
                />
                <Route path="/inventory/item-ledger" element={<ItemLedger />} />
                <Route
                  path="/inventory/adjustment-record"
                  element={<AdjustmentRecord />}
                />
                <Route
                  path="/inventory/transfer-record"
                  element={<TransferRecord />}
                />
                <Route
                  path="/inventory/quick-transfer-voucher/:id"
                  element={<QuickTransferVoucher authInfo={authInfo} />}
                />
                <Route
                  path="/inventory/transfer-pending-record"
                  element={<TransferPendingRecord />}
                />
                <Route
                  path="/inventory/transfer-receive-record"
                  element={<TransferReceiveRecord />}
                />
                <Route path="/inventory/models-manage" element={<Models />} />
                <Route
                  path="/inventory/models-manage/addNewModel"
                  element={<CreateModel />}
                />
                
                <Route path="/inventory/origins-manage" element={<Origins />} />
                <Route path="/inventory/manufacturers" element={<Manufacturers />} />
                <Route
                  path="/inventory/origins-manage/addNewOrigin"
                  element={<CreateOrigins />}
                />
                <Route path="/inventory/racks-manage" element={<Racks />} />
                <Route
                  path="/inventory/racks-manage/addNewRack"
                  element={<CreateRacks />}
                />
                <Route path="/inventory/generic-names" element={<GenericName />} />
                <Route
                  path="/inventory/generic-names/addNewGenericName"
                  element={<CreateGenericNameForm />}
                />
                <Route
                  path="/hrpayroll/dashboard"
                  element={<HRPayrollDashboard authInfo={authInfo} />}
                />

                <Route path="/hrpayroll/departments" element={<Department />} />

                <Route
                  path="/hrpayroll/departments/addNewDepartment"
                  element={<CreateDepartment />}
                />

                <Route
                  path="/hrpayroll/designations"
                  element={<Designations />}
                />
                <Route
                  path="/hrpayroll/designations/addNewDesignation"
                  element={<CreateDesignations />}
                />
                <Route path="/crm/dashboard" element={<CRMDashboard />} />
                <Route path="/crm/performance" element={<Performance />} />
                <Route path="/crm/mywork" element={<MyWork />} />
                <Route path="/crm/tasks" element={<TaskTabs />} />

                <Route
                  path="/crm/customers"
                  element={<CrmCustomers authInfo={authInfo} />}
                />

                <Route
                  path="/crm/customers/addNewCustomer"
                  element={<CreateCrmCustomers authInfo={authInfo} />}
                />
                <Route
                  path="/crm/customer-pending-list"
                  element={<CustomerPendingRecord />}
                />
                <Route
                  path="/crm/customer-approved-list"
                  element={<CustomerApprovedRecord />}
                />
                <Route
                  path="/crm/customer-rejected-list"
                  element={<CustomerRejectedRecord />}
                />
                <Route
                  path="/crm/user-wise-customer-report"
                  element={<CrmReport />}
                />
                <Route path="/crm/leads" element={<Leads />} />
                <Route path="/crm/leads/:id" element={<LeadDetail />} />
                <Route path="/crm/deals" element={<Deals />} />
                <Route path="/crm/deals/:id" element={<DealDetails />} />
                <Route path="/crm/customize" element={<CRMCustomize />} />
                <Route path="/crm/tasks/:id" element={<TaskDetails />} />

                {/* Delivery Section */}
                <Route
                  path="/delivery/dashboard"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="dashboard" />}
                />
                <Route
                    path="/delivery/delivery-execution"
                    element={<DeliveryModule defaultTab="delivery-execution" />}
                />
                <Route
                  path="/delivery/jobs"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="jobs" />}
                />
                <Route
                  path="/delivery/jobs/:id"
                  element={<DeliveryJobDetail authInfo={authInfo} />}
                />
                <Route
                  path="/delivery/routes"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="routes" />}
                />
                <Route
                  path="/delivery/route-points"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="route-points" />}
                />
                <Route
                  path="/delivery/areas"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="areas" />}
                />
                <Route
                  path="/delivery/assignments"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="assignments" />}
                />
                <Route
                  path="/delivery/live-tracking"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="live-tracking" />}
                />
                <Route
                  path="/delivery/status-flow"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="status-flow" />}
                />
                <Route
                  path="/delivery/pickup"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="pickup" />}
                />
                <Route
                  path="/delivery/users"
                  element={<DeliveryModule authInfo={authInfo} defaultTab="users" />}
                />

                <Route
                  path="/accounts/dashboard"
                  element={<AccountsDashboard />}
                />
                <Route
                  path="/accounts/debitor-receipts"
                  element={<CustomerReceiptList />}
                />
                <Route
                  path="/accounts/debitor-receipts/add"
                  element={<CustomerReceipts authInfo={authInfo} />}
                />
                <Route
                  path="/accounts/debitor-receipts/view/:id"
                  element={<CustomerReceiptVoucher authInfo={authInfo} />}
                />
                <Route
                  path="/accounts/advance-transaction/receipt/:id"
                  element={<AdvanceTransactionReceipt authInfo={authInfo} />}
                />
                <Route
                  path="/accounts/debitor-pharma-receipts"
                  element={<InsuranceReceiptList />}
                />
                <Route
                  path="/accounts/debitor-insurance-receipts/add"
                  element={<InsuranceReceipts />}
                />
                <Route
                  path="/accounts/debitor-pharma-receipts"
                  element={<InsuranceReceiptList />}
                />
                <Route
                  path="/accounts/debitor-insurance-receipts/add"
                  element={<InsuranceReceipts />}
                />
                <Route
                  path="/accounts/debitor-pharma-receipts"
                  element={<InsuranceReceiptList />}
                />
                <Route
                  path="/accounts/debitor-insurance-receipts/add"
                  element={<InsuranceReceipts />}
                />
                <Route
                  path="/accounts/debitor-receipts/edit/:id"
                  element={<CustomerReceipts authInfo={authInfo} />}
                />
                <Route
                  path="/accounts/creditor-payments"
                  element={<SupplierPaymentList />}
                />
                <Route
                  path="/accounts/creditor-payments/add"
                  element={<SupplierPayments />}
                />
                <Route
                  path="/accounts/creditor-payments/view/:id"
                  element={<SupplierPaymentVoucher />}
                />
                <Route
                  path="/accounts/creditor-payments/edit/:id"
                  element={<SupplierPayments />}
                />
                <Route path="/accounts/expenses" element={<ExpenseList />} />
                <Route
                  path="/accounts/expenses/add"
                  element={<ExpenseEntry />}
                />
                <Route
                  path="/accounts/expenses/edit/:id"
                  element={<ExpenseEntry />}
                />
                <Route
                  path="/accounts/expense-recognitions"
                  element={<ExpenseRecognitionList />}
                />
                <Route
                  path="/accounts/expense-recognitions/add"
                  element={<ExpenseRecognitionEntry />}
                />
                <Route
                  path="/accounts/expense-recognitions/edit/:id"
                  element={<ExpenseRecognitionEntry />}
                />
                <Route path="/accounts/income" element={<IncomeList />} />
                <Route path="/accounts/income/add" element={<IncomeEntry />} />
                <Route
                  path="/accounts/income/edit/:id"
                  element={<IncomeEntry />}
                />
                <Route
                  path="/accounts/journal-entry"
                  element={<JournalList />}
                />
                <Route
                  path="/accounts/journal-entry/add"
                  element={<JournalEntry authInfo={authInfo} />}
                />
                <Route
                  path="/accounts/journal-entry/edit/:id"
                  element={<JournalEntry authInfo={authInfo} />}
                />
                <Route
                  path="/accounts/recurring-journals"
                  element={<RecurringJournalList />}
                />
                <Route
                  path="/accounts/recurring-journals/add"
                  element={<RecurringJournalEntry authInfo={authInfo} />}
                />

                <Route
                  path="/accounts/advance-tran"
                  element={<AdvanceTransaction />}
                />
                <Route
                  path="/hrpayroll/hr-settings-view"
                  element={<HrSettingsView />}
                />
                <Route path="/settings" element={<SettingsDashboard />} />
                <Route
                  path="/settings/branch-manage"
                  element={<BranchEntry authInfo={authInfo} />}
                />
                <Route
                  path="/settings/branch-manage/addNewBranch"
                  element={<CreateBranchForm authInfo={authInfo} />}
                />
                <Route path="/settings/warehouses" element={<Warehouses />} />
                <Route
                  path="/settings/warehouses/addNewWarehouse"
                  element={<CreateWarehouses />}
                />

                <Route
                  path="/settings/tags"
                  element={<TagManage authInfo={authInfo} />}
                />

                <Route
                  path="/settings/user-manage"
                  element={<UserManage authInfo={authInfo} />}
                />

                <Route
                  path="/settings/institution-profile"
                  element={<InstitutionProfile authInfo={authInfo} />}
                />
                <Route
                  path="/settings/subscription-info"
                  element={<SubscriptionPage authInfo={authInfo} />}
                />

                <Route
                  path="/reports/debitors-balance"
                  element={<CustomerDue />}
                />
                <Route
                  path="/reports/debitors-balance/:id"
                  element={<CustomerDue />}
                />
                <Route
                  path="/reports/debitors-report-due"
                  element={<CustomerDueReport />}
                />
                <Route
                  path="/reports/debitor-balance-ledger"
                  element={<CustomerLedger />}
                />
                <Route
                  path="/reports/collection-record"
                  element={<CollectionReport />}
                />
                <Route
                  path="/reports/debtor-receipt-record"
                  element={<DebtorReceiptRecord />}
                />
                <Route
                  path="/reports/emi-due-list"
                  element={<EMIDueReport />}
                />
                <Route
                  path="/reports/creditors-balance"
                  element={<SupplierDue />}
                />
                <Route
                  path="/reports/creditors-balance/:id"
                  element={<SupplierDue />}
                />
                <Route
                  path="/reports/supplier-wise-outflow"
                  element={<SupplierOutflow />}
                />
                <Route
                  path="/reports/outstanding-pdc"
                  element={<OutstandingPdc />}
                />
                <Route
                  path="/reports/creditor-balance-ledger"
                  element={<SupplierLedger />}
                />
                <Route
                  path="/reports/indirect-expenses-balance"
                  element={<ExpenseBalanceReport />}
                />
                <Route
                  path="/reports/indirect-expenses-balance/:id"
                  element={<ExpenseBalanceReport />}
                />
                <Route
                  path="/reports/expense-record"
                  element={<ExpenseRecord />}
                />
                <Route
                  path="/reports/advance-creditor-balance"
                  element={<AdvanceCreditor />}
                />
                <Route
                  path="/reports/advance-creditor-balance/:id"
                  element={<AdvanceCreditor />}
                />
                <Route
                  path="/reports/creditor-payment-record"
                  element={<CreditorPaymentRecord />}
                />
                <Route
                  path="/reports/current-asset-ledger"
                  element={<CurrentAssetLedger />}
                />
                <Route
                  path="/settings/location-manage/addNewLocation"
                  element={<CreateLocations />}
                />
                <Route
                  path="/settings/warehouses/addNewWarehouse"
                  element={<CreateWarehouses />}
                />
                <Route
                  path="/settings/tags"
                  element={<TagManage authInfo={authInfo} />}
                />
                <Route
                  path="/settings/user-manage"
                  element={<UserManage authInfo={authInfo} />}
                />
                <Route
                  path="/settings/institution-profile"
                  element={<InstitutionProfile authInfo={authInfo} />}
                />
                <Route
                  path="/reports/debitors-balance"
                  element={<CustomerDue />}
                />
                <Route
                  path="/reports/debitors-report-due"
                  element={<CustomerDueReport />}
                />
                <Route
                  path="/reports/debitor-balance-ledger"
                  element={<CustomerLedger />}
                />
                <Route
                  path="/reports/collection-record"
                  element={<CollectionReport />}
                />
                <Route
                  path="/reports/debtor-receipt-record"
                  element={<DebtorReceiptRecord />}
                />
                {/* <Route
                  path="/reports/emi-due-list"
                  element={<EMIDueReport />}
                /> */}
                <Route
                  path="/reports/creditors-balance"
                  element={<SupplierDue />}
                />
                <Route
                  path="/reports/creditor-balance-ledger"
                  element={<SupplierLedger />}
                />

                <Route
                  path="/reports/expense-record"
                  element={<ExpenseRecord />}
                />
                <Route
                  path="/reports/advance-creditor-balance"
                  element={<AdvanceCreditor />}
                />
                <Route
                  path="/reports/creditor-payment-record"
                  element={<CreditorPaymentRecord />}
                />
                <Route
                  path="/reports/current-asset-ledger"
                  element={<CurrentAssetLedger />}
                />
                <Route
                  path="/reports/item-wise-profit"
                  element={<ItemProfitLossReport />}
                />
                <Route
                  path="/reports/bill-wise-profit-loss"
                  element={<BillWiseProfitLossReport />}
                />
                <Route
                  path="/reports/fixed-asset-balance"
                  element={<FixedAssetBalance />}
                />
                <Route
                  path="/reports/fixed-asset-balance/:id"
                  element={<FixedAssetBalance />}
                />
                <Route
                  path="/reports/intangible-asset"
                  element={<IntangibleAssetBalance />}
                />
                <Route
                  path="/reports/intangible-asset/:id"
                  element={<IntangibleAssetBalance />}
                />
                <Route
                  path="/reports/ageing-report"
                  element={<AgeingReport />}
                />
                <Route
                  path="/reports/fixed-asset-ledger"
                  element={<FixedAssetLedger />}
                />
                <Route
                  path="/reports/tax-ledger"
                  element={<SalesTaxLedger />}
                />
                <Route
                  path="/reports/tax-ledger/:id"
                  element={<SalesTaxLedger />}
                />
                <Route path="/reports/gstr-3b-summary" element={<GSTR3BSummary />} />
                <Route path="/reports/gstreturns" element={<SalesReturnGSTR1 />} />
                <Route path="/reports/purchase-gstreturns" element={<PurchaseReturnGSTR2 />} />
                <Route
                  path="/reports/current-assets-report"
                  element={<CurrentAssetBalance />}
                />
                <Route
                  path="/reports/current-assets-report/:id"
                  element={<CurrentAssetBalance />}
                />
                <Route
                  path="/reports/reserve-surplus-ledger"
                  element={<ReserveSurplusLedgerReport />}
                />
                <Route
                  path="/reports/account-transaction-report"
                  element={<UniversalLedger />}
                />
                <Route
                  path="/reports/intangible-asset-ledger"
                  element={<IntangibleAssetLedger />}
                />
                <Route
                  path="/reports/reserve-surplus-balance"
                  element={<ReserveSurplusBalanceReport />}
                />
                <Route
                  path="/reports/reserve-surplus-balance/:id"
                  element={<ReserveSurplusBalanceReport />}
                />
                <Route
                  path="/reports/suspense-ledger"
                  element={<SuspenseLedgerReport />}
                />
                <Route
                  path="/settings/location-manage"
                  element={<Locations />}
                />
                <Route
                  path="/settings/location-manage/addNewLocation"
                  element={<CreateLocations />}
                />
                <Route
                  path="/settings/warehouses/addNewWarehouse"
                  element={<CreateWarehouses />}
                />
                <Route
                  path="/settings/tags"
                  element={<TagManage authInfo={authInfo} />}
                />
                <Route
                  path="/settings/user-role-manage"
                  element={<UserRoleManage authInfo={authInfo} />}
                />
                <Route
                  path="/settings/module-access"
                  element={<ModuleAccessManage />}
                />
                <Route
                  path="/settings/user-manage"
                  element={<UserManage authInfo={authInfo} />}
                />
                <Route
                  path="/settings/institution-profile"
                  element={<InstitutionProfile authInfo={authInfo} />}
                />
                <Route
                  path="/reports/debitors-balance"
                  element={<CustomerDue />}
                />
                <Route
                  path="/reports/debitors-report-due"
                  element={<CustomerDueReport />}
                />
                <Route
                  path="/reports/debitor-balance-ledger"
                  element={<CustomerLedger />}
                />
                <Route
                  path="/reports/collection-record"
                  element={<CollectionReport />}
                />
                <Route
                  path="/reports/debtor-receipt-record"
                  element={<DebtorReceiptRecord />}
                />
                <Route path="/reports/emi-due-list" element={<EmiDueList />} />
                <Route
                  path="/reports/creditors-balance"
                  element={<SupplierDue />}
                />
                <Route
                  path="/reports/creditor-balance-ledger"
                  element={<SupplierLedger />}
                />
                <Route
                  path="/reports/expense-record"
                  element={<ExpenseRecord />}
                />
                <Route
                  path="/reports/advance-creditor-balance"
                  element={<AdvanceCreditor />}
                />
                <Route
                  path="/reports/creditor-payment-record"
                  element={<CreditorPaymentRecord />}
                />
                <Route
                  path="/reports/current-asset-ledger"
                  element={<CurrentAssetLedger />}
                />
                <Route
                  path="/reports/item-wise-profit"
                  element={<ItemProfitLossReport />}
                />
                <Route
                  path="/reports/bill-wise-profit-loss"
                  element={<BillWiseProfitLossReport />}
                />
                <Route
                  path="/reports/manufacturing-record"
                  element={<ManufacturingRecord />}
                />

                <Route
                  path="/reports/reserve-surplus-ledger"
                  element={<ReserveSurplusLedgerReport />}
                />
                <Route
                  path="/reports/reserve-surplus-balance"
                  element={<ReserveSurplusBalanceReport />}
                />
                <Route
                  path="/reports/suspense-ledger"
                  element={<SuspenseLedgerReport />}
                />
                <Route
                  path="/settings/location-manage"
                  element={<Locations />}
                />
                <Route
                  path="/settings/location-manage/addNewLocation"
                  element={<CreateLocations />}
                />
                <Route path="/accounts/account-entry" element={<Accounts />} />
                <Route
                  path="/accounts/account-entry/addNewAccount"
                  element={<CreateAccounts />}
                />
                <Route
                  path="/accounts/opening-balances"
                  element={<OpeningBalances />}
                />
                <Route path="/accounts/contra-entry" element={<Contra />} />
                <Route
                  path="/accounts/contra-entry/addNewContra"
                  element={<CreateContra />}
                />
                <Route
                  path="/accounts/branch-tran"
                  element={<BranchTransactionEntry />}
                />
                <Route
                  path="/accounts/branch-tran/addNewBranchTransaction"
                  element={<CreateBranchTransaction />}
                />
                <Route
                  path="/accounts/bank-transactions"
                  element={<BankTransactionPage authInfo={authInfo} />}
                />
                <Route path="/accounts/cheques" element={<Cheques />} />
                <Route
                  path="/hrpayroll/salary-report"
                  element={<SalaryPaymentReport />}
                />
                <Route
                  path="/reports/salary-report"
                  element={<SalaryPaymentReport />}
                />
                <Route
                  path="/hrpayroll/monthly-salary-report"
                  element={<MonthlySalaryReport />}
                />
                <Route
                  path="/reports/monthly-salary-report"
                  element={<MonthlySalaryReport />}
                />
                <Route
                  path="/hrpayroll/salary-voucher/:id/:month/:year"
                  element={<SalaryPaymentVoucher />}
                />

                <Route
                  path="/hrpayroll/attendance"
                  // element={<AttendanceEntry />}
                  element={<AttendanceTabs />}
                />
                <Route
                  path="/reports/sales-return-ledger"
                  element={<SalesReturnLedger />}
                />
                <Route path="/reports/sales-ledger" element={<SalesLedger />} />
                <Route
                  path="/reports/advance-debtor-balance"
                  element={<AdvanceCustomerBalanceReport />}
                />
                <Route
                  path="/reports/advance-debtor-balance/:id"
                  element={<AdvanceCustomerBalanceReport />}
                />
                <Route
                  path="/reports/purchase-return-ledger"
                  element={<PurchaseReturnLedger />}
                />
                <Route
                  path="/reports/purchase-return-record"
                  element={<PurchaseReturnRecord />}
                />
                <Route
                  path="/reports/purchase-return-record/:id"
                  element={<PurchaseReturnRecord />}
                />
                <Route
                  path="/reports/purchase-ledger"
                  element={<PurchaseAccountLedger />}
                />
                <Route
                  path="/reports/purchase-record"
                  element={<PurchaseRecord />}
                />
                <Route
                  path="/reports/purchase-record/:id"
                  element={<PurchaseRecord />}
                />
                <Route
                  path="/reports/indirect-expense-ledger"
                  element={<IndirectExpenseLedger />}
                />
                <Route
                  path="/reports/direct-expense-ledger"
                  element={<DirectExpenseLedger />}
                />
                <Route
                  path="/reports/direct-expense-balance"
                  element={<DirectExpenseBalance />}
                />
                <Route
                  path="/reports/direct-expense-balance/:id"
                  element={<DirectExpenseBalance />}
                />
                <Route
                  path="/reports/expense-recognition-record"
                  element={<ExpenseRecognitionRecord />}
                />
                <Route
                  path="/hrpayroll/salary-payments"
                  element={<SalaryPaymentList />}
                />
                <Route
                  path="/hrpayroll/salary-payments/add"
                  element={<SalaryPaymentEntry authInfo={authInfo} />}
                />
                <Route
                  path="/hrpayroll/salary-payments/edit/:id"
                  element={<SalaryPaymentEntry authInfo={authInfo} />}
                />

                <Route
                  path="/hrpayroll/clients-entry"
                  element={<ClientsDashboard authInfo={authInfo} />}
                />
                <Route
                  path="/hrpayroll/hrlocation"
                  element={<BranchLocation authInfo={authInfo} />}
                />
                <Route
                  path="/hrpayroll/work-routes"
                  element={<WorkRoutes authInfo={authInfo} />}
                />
                <Route
                  path="/hrpayroll/employees"
                  element={<EmployeesPage authInfo={authInfo} />}
                />
                <Route
                  path="/hrpayroll/onboarding"
                  element={<OnboardingPage authInfo={authInfo} />}
                />
                <Route
                  path="/hrpayroll/onboarding/add"
                  element={<OnboardingForm authInfo={authInfo} />}
                />
                <Route
                  path="/reports"
                  element={<ReportDashboard authInfo={authInfo} />}
                />
                {/* <Route
                  path="/reports/sales-replace-record"
                  element={<ProductReplaceRecord />}
                /> */}
                <Route path="/reports/sales-record" element={<SalesRecord />} />
                <Route
                  path="/reports/sales-record/:id"
                  element={<SalesRecord />}
                />
                <Route
                  path="/reports/account-balance"
                  element={<AccountBalance />}
                />
                <Route
                  path="/reports/account-balance/:id"
                  element={<AccountBalance />}
                />
                <Route
                  path="/reports/account-ledger"
                  element={<CashBankAccountLedger />}
                />
                <Route path="/reports/daily-ledger" element={<DailyLedger />} />
                <Route
                  path="/reports/profit-loss"
                  element={<ProfitLossReport />}
                />
                <Route
                  path="/reports/profit-loss/:id"
                  element={<ProfitLossReport />}
                />
                <Route path="/reports/loan-balance" element={<LoanBalance />} />
                <Route
                  path="/reports/loan-balance/:id"
                  element={<LoanBalance />}
                />
                <Route
                  path="/reports/loan-ledger"
                  element={<LoanBalanceLedger />}
                />
                <Route
                  path="/reports/branch-tran-transfer-list"
                  element={<BranchTransferList />}
                />
                <Route
                  path="/reports/branch-tran-transfer-list/:id"
                  element={<BranchTransferList />}
                />
                <Route
                  path="/reports/indirect-income-ledger"
                  element={<IndirectIncomeBalanceLedger />}
                />
                <Route
                  path="/reports/balance-sheet"
                  element={<BalanceSheet />}
                />
                <Route
                  path="/reports/trial-balance"
                  element={<TrialBalance />}
                />
                <Route
                  path="/settings/location-manage"
                  element={<Locations />}
                />
                {/* <Route
                  path="/settings/location-manage"
                  element={<ProductReplaceRecord />}
                /> */}
                <Route
                  path="/reports/sales-return-record"
                  element={<SalesReturnRecord />}
                />
                <Route
                  path="/reports/sales-return-record/:id"
                  element={<SalesReturnRecord />}
                />
                <Route
                  path="/reports/indirect-income-balance"
                  element={<IndirectIncomeBalance />}
                />
                <Route
                  path="/reports/indirect-income-balance/:id"
                  element={<IndirectIncomeBalance />}
                />
                <Route
                  path="/reports/direct-income-balance"
                  element={<DirectIncomeBalance />}
                />
                <Route
                  path="/reports/direct-income-balance/:id"
                  element={<DirectIncomeBalance />}
                />
                <Route
                  path="/reports/branch-tran-receive-list"
                  element={<BranchTransferReceiveList />}
                />
                <Route
                  path="/reports/branch-tran-receive-list/:id"
                  element={<BranchTransferReceiveList />}
                />
                <Route
                  path="/reports/branch-tran-pending-list"
                  element={<BranchTransferPendingList />}
                />
                <Route
                  path="/reports/direct-income-ledger"
                  element={<DirectIncomeBalanceLedger />}
                />
                <Route
                  path="/reports/branch-ledger"
                  element={<BranchLedger />}
                />
                <Route
                  path="/reports/capital-ledger"
                  element={<CapitalLedger />}
                />
                <Route
                  path="/reports/branch-inward"
                  element={<BranchTransactionInward />}
                />
                <Route
                  path="/reports/branch-tran-outward"
                  element={<BranchTransactionOutward />}
                />
                <Route
                  path="/reports/branch-tran-outward"
                  element={<BranchTransactionOutward />}
                />
                <Route
                  path="/reports/branch-balance-report"
                  element={<BranchBalance />}
                />
                <Route
                  path="/reports/capitals-balance"
                  element={<CapitalBalance />}
                />
                <Route
                  path="/reports/capitals-balance/:id"
                  element={<CapitalBalance />}
                />
                <Route
                  path="/reports/income-record"
                  element={<IncomeRecord />}
                />
                <Route
                  path="/reports/contra-record"
                  element={<ContraRecord />}
                />
                <Route
                  path="/reports/service-expense-ledger"
                  element={<ServiceExpenseLedger />}
                />
                <Route
                  path="/reports/loan-ledger"
                  element={<LoanBalanceLedger />}
                />
                <Route
                  path="/reports/branch-tran-transfer-list"
                  element={<BranchTransferList />}
                />
                <Route
                  path="/reports/branch-tran-transfer-list/:id"
                  element={<BranchTransferList />}
                />
                <Route
                  path="/reports/indirect-income-ledger"
                  element={<IndirectIncomeBalanceLedger />}
                />
                <Route
                  path="/reports/balance-sheet"
                  element={<BalanceSheet />}
                />
                <Route
                  path="/reports/trial-balance"
                  element={<TrialBalance />}
                />

                <Route
                  path="/reports/branch-tran-pending-list"
                  element={<BranchTransferPendingList />}
                />
                <Route
                  path="/reports/direct-income-ledger"
                  element={<DirectIncomeBalanceLedger />}
                />
                <Route
                  path="/reports/suspense-balance"
                  element={<SuspenseBalanceReport />}
                />
                <Route
                  path="/reports/suspense-balance/:id"
                  element={<SuspenseBalanceReport />}
                />
                <Route
                  path="/reports/current-liability-ledger"
                  element={<CurrentLiabilityLedgerReport />}
                />
                <Route
                  path="/reports/current-liablity-report"
                  element={<CurrentLiabilityBalanceReport />}
                />
                <Route
                  path="/reports/current-liablity-report/:id"
                  element={<CurrentLiabilityBalanceReport />}
                />
                <Route
                  path="/reports/deposit-account-ledger"
                  element={<DepositAccountLedgerReport />}
                />
                <Route
                  path="/reports/service-ledger"
                  element={<ServiceAccountLedger />}
                />
                <Route
                  path="/reports/service-ledger/:id"
                  element={<ServiceAccountLedger />}
                />
                <Route
                  path="/reports/investment-ledger"
                  element={<InvestmentAccountLedger />}
                />
                <Route
                  path="/reports/journal-record"
                  element={<JournalRecord />}
                />
                <Route
                  path="/reports/loan-ledger"
                  element={<LoanBalanceLedger />}
                />
                <Route
                  path="/reports/branch-tran-transfer-list"
                  element={<BranchTransferList />}
                />
                <Route
                  path="/reports/branch-tran-transfer-list/:id"
                  element={<BranchTransferList />}
                />
                <Route
                  path="/reports/indirect-income-ledger"
                  element={<IndirectIncomeBalanceLedger />}
                />
                <Route
                  path="/reports/balance-sheet"
                  element={<BalanceSheet />}
                />
                <Route
                  path="/reports/trial-balance"
                  element={<TrialBalance />}
                />

                <Route
                  path="/reports/branch-tran-pending-list"
                  element={<BranchTransferPendingList />}
                />
                <Route
                  path="/reports/direct-income-ledger"
                  element={<DirectIncomeBalanceLedger />}
                />

                <Route
                  path="/reports/current-liability-ledger"
                  element={<CurrentLiabilityLedgerReport />}
                />
                <Route
                  path="/reports/current-liablity-report"
                  element={<CurrentLiabilityBalanceReport />}
                />
                <Route
                  path="/reports/deposit-account-report"
                  element={<DepositAccountRecord />}
                />
                <Route
                  path="/reports/deposit-account-report/:id"
                  element={<DepositAccountRecord />}
                />
                <Route
                  path="/reports/deposit-account-ledger"
                  element={<DepositAccountLedgerReport />}
                />
                <Route
                  path="/reports/investment-balance"
                  element={<InvestmentBalanceReport />}
                />
                <Route
                  path="/reports/investment-balance/:id"
                  element={<InvestmentBalanceReport />}
                />
                <Route path="/contact-support" element={<ContactSupport />} />
                <Route path="/cookies-policy" element={<CookiesPolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-service" element={<TermsOfService />} />
                <Route
                  path="/hrpayroll/attendance-overview"
                  element={<AttendanceOverview />}
                />
                <Route
                  path="/sales/patient-overview"
                  element={<PatientsOverview />}
                />
                <Route
                  path="/sales/doctor-overview"
                  element={<DoctorsOverview />}
                />

                {/* ATS Section */}
                <Route path="/ats/dashboard" element={<ATSDashboard />} />
                <Route
                  path="/ats/jobs"
                  element={<JobsList authInfo={authInfo} />}
                />
                <Route path="/ats/jobs/new" element={<JobNewOrEdit />} />
                <Route path="/ats/jobs/:id/edit" element={<JobNewOrEdit />} />
                <Route path="/ats/jobs/:id/view" element={<JobView />} />

                <Route path="/ats/candidates" element={<CandidatesList />} />
                <Route
                  path="/ats/candidates/new"
                  element={<CreateCandidate />}
                />
                <Route path="/ats/candidates/:id" element={<ViewCandidate />} />
                <Route
                  path="/ats/candidates/:id/edit"
                  element={<EditCandidate />}
                />

                <Route path="/ats/clients" element={<ClientsList />} />
                <Route path="/ats/agencies" element={<AgenciesList />} />
                {/* Optional future “Add New” pages */}
                <Route path="/ats/jobs/new" element={<div>Add Job Form</div>} />
                <Route
                  path="/ats/candidates/new"
                  element={<div>Add Candidate Form</div>}
                />
                <Route
                  path="/ats/clients/new"
                  element={<div>Add Client Form</div>}
                />
                <Route
                  path="/ats/agencies/new"
                  element={<div>Add Agency Form</div>}
                />

                <Route
                  path="/ats/workflows"
                  element={
                    canUseWorkflows ? <WorkflowList /> : hiddenWorkflowRoute
                  }
                />
                <Route
                  path="/ats/workflows/create"
                  element={
                    canUseWorkflows ? (
                      <WorkflowBuilder />
                    ) : (
                      hiddenWorkflowRoute
                    )
                  }
                />
                <Route
                  path="/ats/workflow/:id"
                  element={
                    canUseWorkflows ? (
                      <WorkflowBuilder />
                    ) : (
                      hiddenWorkflowRoute
                    )
                  }
                />
                <Route
                  path="/ats/workflow/new"
                  element={
                    canUseWorkflows ? (
                      <WorkflowBuilder />
                    ) : (
                      hiddenWorkflowRoute
                    )
                  }
                />
                <Route
                  path="/ats/applications/:id"
                  element={<ApplicationView />}
                />

                <Route
                  path="/settings/activities"
                  element={<ActivitiesPage />}
                />

                {/* <Route path="/ats/workflow/tasks" element={<TaskManager />} /> */}

                <Route
                  path="/ats/tasks"
                  element={
                    canUseWorkflows ? (
                      <WorkflowRecords />
                    ) : (
                      hiddenWorkflowRoute
                    )
                  }
                />
                <Route
                  path="/ats/tasks/:recordType/:recordId"
                  element={
                    canUseWorkflows ? (
                      <WorkflowTaskFlow />
                    ) : (
                      hiddenWorkflowRoute
                    )
                  }
                />
              </Route>

              {/* Public candidate-facing job route */}
              <Route
                path="/jobs/:id"
                element={<PublicJobView candidateId={authInfo?.candidateId} />}
              />

              <Route path="/jobs" element={<Outlet />}>
                <Route path=":id/apply" element={<CandidateApplyForm />} />
              </Route>

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </Suspense>
      </App>
    </ConfigProvider>
  );
};

export default AppRoutes;
